import React, { useEffect } from 'react';
import DashboardControl, { AjaxRemoteService } from 'devexpress-dashboard-react';
import { connect } from "react-redux";
const ManageDashboard = (props) => {
  const accessToken = props.oidc.user.access_token;
  const url = `${window._env_.REACT_APP_APIS}/devexpressDashboard`;
  const getToken = () => {
    return accessToken;
  };
  const handleCloseClick = () => {
    // Trigger the Escape key functionality
    const escapeEvent = new KeyboardEvent('keydown', {
      key: 'Escape',
      keyCode: 27,
      code: 'Escape',
      which: 27,
      bubbles: true,
    });
    document.dispatchEvent(escapeEvent);
  };

  return (
    <>
      <style type="text/css">
        
        {`
        
        .dx-scrollable-content {
          position: relative;
          min-height: 100%;
          box-sizing: border-box;
        }
        
        .dx-scrollable-content::before,
        .dx-scrollable-content::after {
          display: table;
          content: "";
          line-height: 0;
        }
        
        .dx-scrollable-content::after {
          clear: both;
        }
        
          .custom-close-button {
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 1000;
            background-color: transparent;
            border: none;
            cursor: pointer;
          }

          .custom-close-button svg {
            fill: #ffffff; /* White color */
            width: 24px;
            height: 24px;
            transition: fill 0.3s;
          }

          .custom-close-button:hover svg {
            fill: #e0e0e0; /* Light gray on hover */
          }
        `}
      </style>
      <div style={{ width: "100%", height: "100%", position: 'relative' }}>
        <button className="custom-close-button" onClick={handleCloseClick}>
          {/* SVG Close Icon */}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.71a1 1 0 00-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 101.41 1.41L12 13.41l4.89 4.89a1 1 0 101.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.41z" />
          </svg>
        </button>
        <DashboardControl
          style={{ height: '100%' }}
          workingMode="Designer"
          DataSourceCacheEnabled="false"
          loadDefaultDashboard={false}
          endpoint={url}
        >
          <AjaxRemoteService
            headers={{
              Authorization: `Bearer ${getToken()}`,
            }}
          />
        </DashboardControl>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(ManageDashboard);
